import { v4 as uuidv4 } from "uuid";

import { ItemTypes } from "containers/Form/SimplifiedBuilder/Internal/ItemTypes";

const ELEMENT_TEMPLATE = {
	labelAlign: "top",
	size: 12,
	ignore: false,
	visible: true,
	enabled: true,
	isRequired: false,
	label: "",
	i18n: {
		// eslint-disable-next-line camelcase
		en_us: {
			label: ""
		}
	},
	extraSettings: {}
};

const DEFAULT_GROUP = "formElement";
export const GROUPS = [
	{
		id: "formElement",
		name: "Form Elements",
		itemType: ItemTypes.COMPONENT
	},
	{
		id: "sponsoredProject",
		name: "Sponsored Project",
		itemType: ItemTypes.SINGLE_COLUMN_COMPONENT
	}
];

export const getPaletteItemsByGroup = components => {
	const paletteItemsByGroup = {};
	for (const group of GROUPS) {
		paletteItemsByGroup[group.id] = [];
	}
	const paletteItemIds = [];
	for (const type of Object.keys(components)) {
		if (components[type].showInPalette()) {
			const paletteInformation = components[type].paletteInformation();
			if (paletteItemIds.indexOf(paletteInformation.id) === -1) {
				paletteItemIds.push(paletteInformation.id);
				const group = paletteItemsByGroup[paletteInformation.group] || paletteItemsByGroup[DEFAULT_GROUP];
				const paletteItem = {
					...paletteInformation
				};
				group.push(paletteItem);
			}
		}
	}

	return paletteItemsByGroup;
};

export const generateValue = () => {
	const value = uuidv4().replace(/-/g, "");

	// first character in the expression can't be numeric
	return `{{v${value}}}`;
};

export const createNewElementByType = (components, type, itemType) => {
	const initialValue = components[type].initialValue;

	return {
		...ELEMENT_TEMPLATE,
		...components[type].newElement(),
		id: uuidv4(),
		itemType,
		value: (typeof initialValue === "string" && initialValue.length > 0) ? initialValue : generateValue(),
	};
};
